import React from 'react';
import { Shield, Users, Settings, Cloud, MessageSquare } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  Shield: Shield,
  Users: Users,
  Settings: Settings,
  Cloud: Cloud,
  MessageSquare: MessageSquare
};

const Services = () => {
  return (
    <section id="services" className="py-20 bg-[#0077B6]">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="flex flex-wrap items-center justify-between gap-6 mb-12">
          <div>
            <span className="text-white/80 font-semibold tracking-wider text-sm uppercase">Our Solutions</span>
            <h2 className="text-white text-3xl md:text-4xl font-bold mt-2">
              Comprehensive Technology Services<br className="hidden md:block" />
              Tailored to Your Business
            </h2>
          </div>
          <a
            href="#contact"
            className="px-8 py-3.5 bg-[#0a2342] text-white font-semibold rounded-full hover:bg-[#162f4d] transition-colors uppercase tracking-wide text-sm"
          >
            Learn More
          </a>
        </div>

        {/* Services Grid - First Row */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
          {services.slice(0, 3).map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative overflow-hidden rounded-2xl bg-white shadow-xl hover:shadow-2xl transition-all duration-300"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-[#0a2342] text-xl font-bold mb-3">{service.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{service.description}</p>
                </div>
                {/* Hover Icon */}
                <div className="absolute top-4 right-4 w-12 h-12 bg-[#0077B6] rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {IconComponent && <IconComponent className="text-white" size={24} />}
                </div>
              </div>
            );
          })}
        </div>

        {/* Services Grid - Second Row */}
        <div className="grid md:grid-cols-2 gap-6">
          {services.slice(3, 5).map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative overflow-hidden rounded-2xl bg-white shadow-xl hover:shadow-2xl transition-all duration-300"
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-[#0a2342] text-xl font-bold mb-3">{service.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{service.description}</p>
                </div>
                {/* Hover Icon */}
                <div className="absolute top-4 right-4 w-12 h-12 bg-[#0077B6] rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {IconComponent && <IconComponent className="text-white" size={24} />}
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom Text */}
        <div className="mt-12 text-center">
          <p className="text-white/90 text-lg max-w-4xl mx-auto leading-relaxed">
            Every engagement begins with a <strong>comprehensive assessment</strong> of your current technology landscape. We identify opportunities for optimization, address security vulnerabilities, and develop a strategic roadmap aligned with your business objectives.
          </p>
          <p className="text-white/80 mt-4 max-w-4xl mx-auto leading-relaxed">
            Our team brings <strong>deep expertise across regulated industries</strong> including healthcare, legal, financial services, manufacturing, and government sectors. We understand the unique compliance requirements and operational challenges you face.
          </p>
          <a
            href="#contact"
            className="inline-block mt-8 px-8 py-3.5 bg-white text-[#0077B6] font-semibold rounded-full hover:bg-gray-100 transition-colors"
          >
            Request a Consultation
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
